"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLOOR = void 0;
exports.FLOOR = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: () => {
        throw new Error('Function:FLOOR not implemented');
    },
};
//# sourceMappingURL=floor.js.map